export default __webpack_public_path__ + "static/media/P-025.0fd97615.png";